import colors from 'vuetify/es5/util/colors'

const state = {
  mode: 'light',
  themeColor: 'pink',
  user: {
    avatar: 'static/drlogic-rect-white.png',
    name: 'Dr. Logic',
    admin: false,
  },
}

// getters
const getters = {
  getThemeColor: state => {
    return colors[state.themeColor].base
  },
  getToken: state => {
    return state.token
  },
  getUserData: state => {
    return state.user
  },
}

// actions
const actions = {}

// mutations
const mutations = {
  setThemeColor(state, payload) {
    state.themeColor = payload
  },
  setToken(state, payload) {
    state.token = payload
  },
  setUserData(state, payload) {
    state.user = payload
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
